import {
    ApplicationDispatch,
    SET_SERVER_MESSAGE
  } from "../store/application/types";
import { postData } from "./fetch";
import { queryCache } from "react-query";

export const postMergePdf = async (dispatch: ApplicationDispatch, applicationId: string) => {
    try {
        const url = `api/pdfmerge/merge/${applicationId}`;
        const result: { message: string, error: boolean } = await postData(url);
        await queryCache.refetchQueries("application");
        dispatch({
            type: SET_SERVER_MESSAGE,
            payload: {isError: result.error, message: result.message},
        });
    } catch (error) {
        dispatch({
            type: SET_SERVER_MESSAGE,
            payload: { isError: true, message: error as string},
        });
    }
}
  
  

  
  